export const API_BASE_URL =
  process.env.NODE_ENV == 'production' || process.env.REACT_APP_DEV_REMOTE == 'remote'
    ? process.env.REACT_APP_BACKEND_SERVER + '/dashboard/'
    : 'https://luxury-cart.beeinteractivemedia.com/dashboard/';
export const DOWNLOAD_BASE_URL =
  process.env.NODE_ENV == 'production' || process.env.REACT_APP_DEV_REMOTE == 'remote'
    ? process.env.REACT_APP_BACKEND_SERVER + '/download/'
    : 'https://luxury-cart.beeinteractivemedia.com/download/';
export const ACCESS_TOKEN_NAME = 'x-auth-token';
